import { Loading as LoadingStyle } from './styles'

export interface ILoadingProps {
  color?: string
}

const Loading = ({ color }: ILoadingProps): JSX.Element => (
  <LoadingStyle data-testid="tst-loading" color={color} />
)

export default Loading
